import styled from "styled-components"

export const Wrapper = styled.div`
    margin-top: 30px;
`

export const Title = styled.h3``

export const StyledForm = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
    font-size: var(--fontS);
    font-weight: 600;
`

export const StyledInput = styled.input`
    color-scheme: dark;
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: none;
    border-bottom: 1px solid var(--primary);
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledTextArea = styled.textarea`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: 1px solid var(--primary);
    height: 100px;

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }
`